import { render, staticRenderFns } from "./ordered.vue?vue&type=template&id=0266c0ed&scoped=true&"
import script from "./ordered.vue?vue&type=script&lang=js&"
export * from "./ordered.vue?vue&type=script&lang=js&"
import style0 from "./ordered.sass?vue&type=style&index=0&id=0266c0ed&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0266c0ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/goeatBackup/goeat-backup-goeat-order-line/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
